import { Box, Flex, Text } from "@chakra-ui/react"
import React, { ReactNode } from "react"

type Props = {
  name: string;
  children: ReactNode;
}

const EmailProperty = ({ name, children }: Props) => (
  <Flex mb={8} align="top" lineHeight={1.2}>
    <Text fontWeight="semibold" w={1 / 4} flexShrink={0} mr={3}>{name}</Text>
    <Box w="100%">{children}</Box>
  </Flex>
)

export default EmailProperty
